<template>
    <b-sidebar sidebar-class="task-details"
               title="事項詳情"
               right
               shadow
               backdrop-variant="dark"
               backdrop
               no-close-on-route-change
               v-on:hidden="closeSidebar"
               v-model="isCardInfoShown">

        <div class="mx-3 mt-2 mb-3"
             v-if="task">
            <p class="mb-1">
                {{ createdAt }}
            </p>
            <h4 class="font-weight-bolder">
                {{ title }}
            </h4>
        </div>

        <div class="m-2">
            <task-service class="mb-2"
                          v-if="taskType === 'service'"
                          v-bind:task-id="taskId"
                          v-bind:service="service"
                          v-bind:sku="sku">
            </task-service>

            <task-owner class="mb-2"
                        v-if="userRole === 'vending-admin'"
                        v-bind:task-id="taskId"
                        v-bind:owner="owner">
            </task-owner>

            <task-map class="mb-2"
                      v-bind:task-id="taskId"
                      v-bind:site="site">
            </task-map>

            <task-approve class="mb-2"
                          v-bind:response="stageResponse"
                          v-bind:stage="stage">
            </task-approve>

            <task-inspect class="mb-2"
                          v-bind:response="stageResponse"
                          v-bind:stage="stage">
            </task-inspect>

            <task-schedule class="mb-2"
                           v-bind:response="stageResponse"
                           v-bind:stage="stage">
            </task-schedule>

            <task-complete class="mb-2"
                           v-if="stage === '6000fe508d65ee9ddee9f77f'"
                           v-bind:response="stageResponse"
                           v-bind:stage="stage">
            </task-complete>
        </div>

        <!-- <div class="m-2">
            <tasklet-list v-bind:task-id="taskId"
                          v-bind:tasklets="tasklets">
            </tasklet-list>
        </div> -->
    </b-sidebar>
</template>

<script>
import { BSidebar, } from "bootstrap-vue";

import FieldEditable from "./TaskDetails/FieldEditable";
import TaskletList from "./TaskDetails/TaskletList";
import TaskMap from "./TaskDetails/TaskMap";
import TaskService from "./TaskDetails/TaskService";
import format from "date-fns/format";
import {zhTW} from "date-fns/locale";
import TaskApprove from "./TaskDetails/TaskApprove";
import TaskComplete from "./TaskDetails/TaskComplete";
import TaskInspect from "./TaskDetails/TaskInspect";
import TaskSchedule from "./TaskDetails/TaskSchedule";
import TaskOwner from "./TaskDetails/TaskOwner";

export default {
    name: "TaskDetails",
    components: {
        TaskOwner,
        TaskSchedule,
        TaskInspect,
        TaskComplete,
        TaskApprove,
        TaskService,
        TaskMap,
        TaskletList,
        FieldEditable,
        BSidebar,
    },
    data () {
        return {
            isCardInfoShown: false,

            isTitleInputWrapperActive: false,

            title: "",
            description: "",
            //site: null,
            service: null,
            sku: null,
        };
    },
    computed: {
        user () {
            return this.$store.state.user.user;
        },
        userRole () {
            return this.user.role;
        },

        isKanban () {
            return this.$route.path.includes("/tasks/kanban");
        },
        taskId () {
            return this.$route.params.taskId;
        },
        task () {
            return this.$store.getters["tasks/getTaskById"](this.taskId);
        },
        taskType () {
            return this.task?.type ?? "";
        },
        site () {
            return this.task?.site ?? undefined;
        },
        owner () {
            return this.task.owner;
        },
        stage () {
            return this.task?.stage ?? "";
        },
        stageResponse () {
            return this.task?.stageResponse ?? {};
        },
        createdAt () {
            return format(
                new Date(this.task.createdAt),
                "PPP p",
                {
                    "locale": zhTW,
                }
            );
        },
        tasklets () {
            if (
                this.task &&
                Array.isArray(this.task.tasks)
            ) {
                return this.task.tasks;
            }
            return [];
        },
    },
    methods: {
        closeSidebar () {
            this.isCardInfoShown = false;
            this.$router.push(this.isKanban ? "/tasks/kanban" : "/tasks/list");
        },

        async save (field) {
            if (
                this[field] &&
                this.task[field] !== this[field]
            ) {
                const temp = {
                    _id: this.taskId,
                }
                temp[field] = this[field];

                await this.$store
                    .dispatch(
                        "tasks/edit",
                        temp
                    );
            }
        },
    },
    mounted () {
        if (this.taskId) {
            this.isCardInfoShown = true;
        }

        if (this.task) {
            this.title = this.task.title;
            this.description = this.task.description;
            //this.site = this.task.site;
            this.service = this.task.service;
            this.sku = this.task.sku;
        }
    },
    watch: {
        taskId (newVal) {
            if (newVal) {
                this.isCardInfoShown = true;
            }
        },

        task (newVal) {
            if (newVal) {
                this.title = newVal.title;
                this.description = newVal.description;
                //this.site = newVal.site;
                this.service = newVal.service;
                this.sku = newVal.sku;
            }
        },
    },
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
.task-details {
    width: 40vw;
    min-width: 320px;
}
</style>
